import dayjsGenerateConfig from 'rc-picker/es/generate/dayjs';
import generatePicker from 'antd/es/date-picker/generatePicker';
import 'antd/es/date-picker/style/index';
// 修复 dayjs 生成配置中缺失的毫秒相关方法
var enhancedDayjsConfig = Object.assign(Object.assign({}, dayjsGenerateConfig), {
  // 添加缺失的毫秒相关方法
  getMillisecond: function getMillisecond(date) {
    return date.millisecond();
  },
  setMillisecond: function setMillisecond(date, millisecond) {
    return date.millisecond(millisecond);
  }
});
var DatePicker = generatePicker(enhancedDayjsConfig);
export default DatePicker;